// @flow
export { default } from './PartnerContent';



// WEBPACK FOOTER //
// ./src/components/partner/PartnerContent/index.js